export default () => ({
  handler: 'relativeUrl',
  data: ({ offerSlug }) => `/offer/${offerSlug || ''}`,
});
